export default __webpack_public_path__ + "static/media/base-report1.a137f200.png";